<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="捆包号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectWarehouseList('brand_id')">
                <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.sync_status" placeholder="同步状态">
                <el-option :value="0" label="未同步"></el-option>
                <el-option :value="1" label="已同步"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectWarehouseList('original_thickness')">
                <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <div class="search_time search_inputBox">
                <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库时间"></el-date-picker>
            </div> -->
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.original_bale" placeholder="供单号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.opening_company_id" placeholder="货权单位" @visible-change="getSelectWarehouseList('opening_company_id')">
                <el-option v-for="list in selectMapC.opening_company_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.status" placeholder="资源状态">
                <el-option v-for="list in statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-input v-model="params.price_min" placeholder="价格区间" size="mini"></el-input>
                ~
                <el-input v-model="params.price_max" placeholder="价格区间" size="mini"></el-input>
            </div>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.storage_age" placeholder="库龄" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.storage_location" placeholder="库位" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.attribute_id" multiple collapse-tags placeholder="属性" @visible-change="getSelectWarehouseList('attribute_id')">
                <el-option v-for="list in selectMapC.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.color_id" multiple collapse-tags placeholder="选色" @visible-change="getSelectWarehouseList('color_id')">
                <el-option v-for="list in selectMapC.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注" size="mini"></el-input>
            <!-- <el-select class="search_select search_inputBox" v-model="params.port_id" multiple collapse-tags placeholder="目的港">
                <el-option v-for="list in portList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <!-- <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <!-- <el-button  class="publicBtn" @click="filterDialogVisible=!filterDialogVisible">过滤</el-button> -->
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="syncClick">定向同步</el-button>
            <el-button class="funcPublicBtn" @click="tiao(1)">定价</el-button>
            <el-button class="funcPublicBtn" @click="tiao(2)">调价</el-button>
            <el-button class="funcPublicBtn" @click="cancelSync">撤销同步</el-button>
            <div class="selectConditionTip" v-if="syncSupplierList.length>0">定向贸易商:
                <div class="searchCon" v-for="item in syncSupplierList" :key="item.id">{{item.name}}
                    <div class="searchConDel" @click="removeSyncSupplierList([item.id])">x</div>
                </div>
                <div class="clearSelectAll" @click="resetSyncSupplierList">清除全部</div>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="inventory.sync.spots" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalNumber" v-if="totalObj.numbers||Number(totalObj.numbers)==0">总件数: {{totalObj.numbers}}</div>
            <div class="totalNumber" v-if="totalObj.cube_total||Number(totalObj.cube_total)==0">总方数: {{totalObj.cube_total}}</div>
            <div class="totalNumber" v-if="totalObj.cloud_numbers||Number(totalObj.cloud_numbers)==0">云链件数: {{totalObj.cloud_numbers}}</div>
            <div class="totalNumber" v-if="totalObj.cloud_cube||Number(totalObj.cloud_cube)==0">云链方数: {{totalObj.cloud_cube}}</div>
            <div class="totalNumber" v-if="totalObj.lock_numbers||Number(totalObj.lock_numbers)==0">锁定件数: {{totalObj.lock_numbers}}</div>
            <div class="totalNumber" v-if="totalObj.lock_cube_total||Number(totalObj.lock_cube_total)==0">锁定方数: {{totalObj.lock_cube_total}}</div>
            <div class="totalNumber">选中件数: {{selectRow.length}}</div>
            <div class="totalNumber">选中立方: {{selectCube}}m³</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.sync.spots" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 修改 dialog START -->
        <el-dialog v-dialog-drag :title="setType==1?'定价':'调价'" :visible.sync="addDialogVisible" class="eldialog eldialogSalePrice" :modal="false" custom-class="full_dialog">
            <div v-if="setType==1">
                <el-form :model="set_params" ref="add_form" class="dialogFormB clearfix">
                    <div class="eldialogSetPriceBox clearfix">
                        <el-form-item label="最低价：">
                            <el-input v-model="set_params.min_price" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogSetPriceBox clearfix">
                        <el-form-item label="挂牌价：">
                            <el-input v-model="set_params.sales_price" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <!-- <div class="eldialogSetPriceBox">
                        <el-form-item label="状态：">
                            <el-select v-model="set_params.status">
                                <el-option v-for="(list,index) in selectMessage.status" :key="index" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div> -->
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="setChangePrice">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                </div>
            </div>
            <div v-if="setType==2">
                <el-form :model="transform_params" class="dialogFormB clearfix">
                    <div class="eldialogTransformPriceBox clearfix">
                        <el-form-item label="最低价：">
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">+</span>
                                <el-input v-model="transform_params.min_up" @input="transformInput($event,'min_up')" placeholder="上涨"></el-input>
                            </div>
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">-</span>
                                <el-input v-model="transform_params.min_down" @input="transformInput($event,'min_down')" placeholder="下调"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="挂牌价：">
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">+</span>
                                <el-input v-model="transform_params.set_up" @input="transformInput($event,'set_up')" placeholder="上涨"></el-input>
                            </div>
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">-</span>
                                <el-input v-model="transform_params.set_down" @input="transformInput($event,'set_down')" placeholder="下调"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="transformChangePrice">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 修改 dialog END -->
        <!-- 同步云链 START -->
        <el-dialog v-dialog-drag title="定向同步" :visible.sync="dialogVisibleSync" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="sync" class="clearfix dialogFormB">
                <el-form-item label="选择同行：">
                    <el-select v-model="sync.peer_company" multiple collapse-tags filterable remote :remote-method="getSyncSupplier">
                        <el-option v-for="item in syncSupplier" :key="item.id" :value="item.name" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="同步立方：">
                    <el-select v-model="sync.field">
                        <el-option value="sales_cube" label="销售立方"></el-option>
                        <el-option value="check_cube" label="检尺立方"></el-option>
                        <el-option value="original_cube" label="码单立方"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                </el-form-item>
                <div class="elFormBoxBtnListCol">
                    <el-button class="funcPublicBtn" @click="dialogVisibleSync=!dialogVisibleSync" style="margin-right:15px!important;">取消</el-button>
                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveSync">确认</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!-- 同步云链 END -->
    </div>
</template>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                dialogVisibleWidth:false,
                isShowMore:false,
                widthList:[],
                inbound_time:"",
                params:{
                    supplier_id:"",
                    breed_id:"",
                    thickness:"",
                    length:"",
                    grade_id:"",
                    bale_no:"",
                    warehouse_id:"",
                    attribute_id:"",
                    color_id:"",
                    price_min:"",
                    price_max:"",
                    contract_no:"",
                    bill_lading_no:"",
                    storage_age:"",
                    storage_location:"",
                    opening_company_id:"",
                    original_bale:"",
                    remark:"",
                    sync_status:"",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    attribute_id:[],
                    color_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    opening_company_id:[]
                },
                searchCityList:[],
                statusList:[],
                // dialog
                dialogVisible : false,
                tableCol:[	
                    // {colName:"资源状态",colKey:"stock_status_text",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"供单号",colKey:"original_bale",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"同步状态",colKey:"sync_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"产品图片",colKey:"thumbnail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"sales_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"sales_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"检尺立方",colKey:"check_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"成本价",colKey:"cost_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"min_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"最低价",colKey:"sales_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"云链最低价",colKey:"cloud_min_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"云链挂牌价",colKey:"cloud_sales_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                    // {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"产地",colKey:"place_origin",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"锁定人",colKey:"locker_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"锁定等级",colKey:"lock_level",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,islockLevel:true},
                    // {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"入库时间",colKey:"inbound_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"到期日",colKey:"expiry_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"库龄",colKey:"storage_age",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"库位",colKey:"storage_location",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{
                    // numbers:0,
                    // cube_total:0,
                    // lock_numbers:0,
                    // lock_cube_total:0

                    cloud_cube:0.0000,
                    cloud_numbers: 0,
                    lock_cube: 0.0000,
                    lock_numbers: 0,
                    numbers: 0,
                    percentage: 0,
                    total_cube:0.0000
                },
                fields:"",
                filterDialogVisible:false,
                filter:"",
                selectRow:[],
                selectCube:0.0000,
                setType:1,
                addDialogVisible:false,
                transform_params:{
                    ids:[],
                    min_up:"",
                    min_down:"",
                    set_up:"",
                    set_down:""
                },
                set_params:{
                    ids:[],
                    min_price:"",
                    sales_price:"",
                    status:""
                },
                selectMessage:[],
                dialogVisibleSync:false,
                sync:{
                    ids:[],
                    field:"",
                    peer_company:[]
                },
                proList:[],
                cityList:[],
                province_id:"",
                locationList:[],
                syncSupplier:[],
                syncSupplierList:[]
            }
        },
        created(){
            this.getArea().then(resolve=>{
                this.proList=resolve.data.data;
            })
            this.postFunc("/erp/price.select",{},res=>{
                this.selectMessage.status=res.data.data;
                this.selectMessage.status.push({id:999,name:"全部状态"})
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.postFunc("/erp/inventory.spots.status",{},res=>{
                this.statusList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            removeSyncSupplierList(id){
                this.$confirm('是否确定删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/inventory.remove.peers",{id:id},()=>{
                        this.tip("操作成功","success")
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            resetSyncSupplierList(){
                let arr = new Array()
                this.syncSupplierList.forEach(item=>{
                    arr.push(item.id)
                })
                this.removeSyncSupplierList(arr)
            },
            getDirectionSyncSupplier(){
                this.postFunc("/erp/inventory.assign.peers",{},res=>{
                    this.syncSupplierList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSyncSupplier(e){
                this.postFunc("/erp/company.select",{keyword:e},res=>{
                    this.syncSupplier = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getlocation(){
                this.postFunc("/erp/warehouse.area.select",{},res=>{
                    this.locationList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            cancelSync(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let flag = true;
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        if(item.sync_status == 1){
                            arr.push(item.id)
                        }else{
                            flag = false;
                        }
                    })
                    if(flag){
                        this.$confirm('是否确定撤销同步?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.postFunc("/erp/inventory.assign.cancel",{ids:arr},()=>{
                                this.tip("撤销成功","success")
                                this.getList();
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    }else{
                        this.tip("有资源未同步，无需撤销同步。","warning")
                    }
                }
            },
            syncClick(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    this.selectRow.forEach(item=>{
                        this.sync.ids.push(item.id)
                    })
                    this.dialogVisibleSync = true;
                }
            },
            saveSync(){
                this.$confirm('是否确定同步?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.proList.forEach(item=>{
                        if(item.id == this.province_id){
                            this.sync.province = item.name;
                        }
                    })
                    this.postFunc("/erp/inventory.assign.submit",this.sync,()=>{
                        this.tip("同步成功","success")
                        this.dialogVisibleSync = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            changePro(val,type){
                this.getArea(val).then(resolve=>{
                    this.cityList=resolve.data.data;
                    this.sync.city="";
                })
            },
            tiao(type){
                this.addDialogVisible = !this.addDialogVisible;
                this.setType = type;
                let arr = new Array();
                this.selectRow.forEach(item=>{
                    arr.push(item.id)
                })
                this.changeIds=arr;
            },
            transformInput(e,type){
                if(type=="min_up"){
                    this.transform_params.min_down = "";
                }else if(type=="min_down"){
                    this.transform_params.min_up = "";
                }else if(type=="set_up"){
                    this.transform_params.set_down = "";
                }else if(type=="set_down"){
                    this.transform_params.set_up = "";
                }
            },
            setChangePrice(){
                this.$confirm('是否确认定价?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.set_params.ids = this.changeIds;
                    this.postFunc("/erp/cloud.create.price",this.set_params,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            transformChangePrice(){
                this.$confirm('是否确认修改?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let obj = new Object();
                    obj.ids = this.changeIds;
                    // this.transform_params.ids=this.changeIds;
                    if(this.transform_params.min_down == ""){
                        obj.min_price = this.transform_params.min_up
                    }else if(this.transform_params.min_up == ""){
                        obj.min_price = -this.transform_params.min_down
                    } 
                    if(this.transform_params.set_down == ""){
                        obj.sales_price = this.transform_params.set_up
                    }else if(this.transform_params.set_up == ""){
                        obj.sales_price = -this.transform_params.set_down
                    }
                    this.postFunc("/erp/cloud.update.price",obj,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getRow(row){
                this.selectRow = row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.sales_cube)
                })
                this.selectCube = this.keepLimit(number)
            },
            exportExcelBill(){
                this.$exportExecl("/erp/inventory.sync.spots.export","云链管理",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                // this.params.inbound_time=parseInt(new Date(this.inbound_time).getTime()/1000)
                this.tableLoading = true;
                this.$postColumnList("/erp/inventory.sync.spots",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.totalObj=res.data.data.total;
                    this.list.forEach((item,ind)=>{
                        if(item.inbound_time){
                            this.list[ind].inbound_time = this.formatTime(this.list[ind].inbound_time+"000")
                        }else{
                            this.list[ind].inbound_time = "";
                        }
                        item.baseColor = "";
                        if(item.sync_status==1){
                            item.baseColor="#ff0000";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                    this.getDirectionSyncSupplier()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            reset(){
                // this.inbound_time="";
                this.params=this.resetSearch(this.params)
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.transform_params = {ids:[],min_up:"",min_down:"",set_up:"",set_down:""}
                    this.set_params = {ids:[],min_price:"",sales_price:"",status:""}
                    this.setType = 1;
                }
            },
            dialogVisibleSync:function(val){
                if(!val){
                    this.sync = {ids:[],field:"",province:"",city:"",sale:"",visible:""};
                    this.province_id = "";
                }
            }
        }
    }
</script>
<style scoped>
    .syncCheckBox{width:235px;margin: auto;margin-top:15px;cursor: pointer;}
    .syncName{font-size: 12px;float: left;width:95px;text-align: right;margin-left:15px;}
    .syncImg{width:15px;height:15px;display: block;float: left;margin-left:10px;}
    .dialogFormB >>> .el-select .el-input.is-focus .el-input__inner{height:28px!important;overflow: hidden;}
    .dialogFormB >>> .el-select__tags-text{max-width:100px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
    .selectConditionTip{float:left;text-align: center;z-index: 0;line-height: 33px;font-size: 14px;}
    .searchCon{display: inline-block;margin-right:5px;border:1px solid #b21111;border-radius: 3px; padding:3px 15px 3px 3px;position: relative;font-size: 12px;height: 25px;line-height: 17px;}
    .searchConDel{font-size: 12px;color: #b21111;position: absolute;right:3px;top:1px;cursor: pointer;}
    .clearSelectAll{font-size: 12px;color:#b21111;display: inline-block;cursor: pointer;}
</style>